import dayjs from 'dayjs';

export const DEFAULT_FILTERS = {
  status: [],
  query: '',
  powerBuyers: [],
  sellerName: '',
  minActions: undefined,
  areas: [],
  createdAtRange: [dayjs().subtract(5, 'day'), dayjs()],
  minBedrooms: undefined,
  minBathrooms: undefined,
  source: undefined,
};

export const DEAL_SUBMISSION_STATUS_OPTIONS = [
  {
    label: 'Draft',
    value: 'draft',
  },
  {
    label: 'Review',
    value: 'review',
  },
  {
    label: 'Missing Info',
    value: 'missing_info',
  },
  {
    label: 'Revised Offer',
    value: 'revised_offer',
  },
  {
    label: 'Pending Agreement',
    value: 'pending_agreement',
  },
  {
    label: 'Pending Inspection',
    value: 'pending_inspection',
  },
  {
    label: 'Closing',
    value: 'closing',
  },
  {
    label: 'Rejected By UW',
    value: 'rejected_by_uw',
  },
  {
    label: 'Rejected By Seller',
    value: 'rejected_by_seller',
  },
  {
    label: 'Rejected By Buyer',
    value: 'rejected_by_buyer',
  },
];

export const BEDS_OPTIONS = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
];

export const BATHS_OPTIONS = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
];

export const DEAL_TYPE_OPTIONS = [
  { label: 'Wholesale', value: 'deal' },
  { label: 'Pre-Lock', value: 'pre-deal' },
];
